/**
 * @category Utils
 *
 * @module Camera Helpers
 * @alias module:CameraHelpers
 */

import * as THREE from 'three';

/**
 *
 * @function
 * @desc Returns a vector x units in front of the camera
 * @param {THREE.PerspectiveCamera} camera - The camera to get the position from
 * @param {int|float} distance - The distance in front of the camera
 * @param {int|float} [yOffset=0] - The offset above ground level
 * @returns {THREE.Vector3}
 */
export const getDistanceXInCameraDirection = (
	camera,
	distance,
	yOffset = 0,
) => {
	const vec = new THREE.Vector3();
	camera.getWorldDirection(vec);
	vec.multiplyScalar(distance);
	vec.setY(yOffset);
	return vec;
};

export const rotateGLBTowardsCamera = (model, camera) => {

	const modelPosition = new THREE.Vector3();
	const cameraPosition = new THREE.Vector3();
	const direction = new THREE.Vector3();

	model.getWorldPosition(modelPosition);
	camera.getWorldPosition(cameraPosition);

	direction.subVectors(cameraPosition, modelPosition);
	direction.y = 0; // Maintain the y-axis

	const quaternion = new THREE.Quaternion();
	quaternion.setFromUnitVectors(
		new THREE.Vector3(0, 0, 1),
		direction.normalize(),
	);

	model.quaternion.copy(quaternion);
};


